// extracted by mini-css-extract-plugin
module.exports = {"logout":"Logout_logout__3HF2I","exitApp":"Logout_exitApp__2WIER"};